import { Component, OnInit, AfterViewInit, inject } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'interview-welcome',
    templateUrl: './welcome.component.html',
    standalone: false
})
export class WelcomeComponent implements OnInit, AfterViewInit {
    private translate = inject(TranslateService);

    instructions:any;

    constructor() {}

    ngOnInit() {}

    ngAfterViewInit() {
        this.translate.get('interviews.Welcome Page Title').subscribe(title => {
            document.title = title;
        });
    }
}
